// extracted by mini-css-extract-plugin
export default {"root":"hRP8TnXW","date":"mtKANEqr","text":"wfttcqlT","container":"CKvXMZwz","win":"mNPeBtIv","loss":"w2TqI9bH","value":"xyFc77O7","trades":"WmxIGeWE","icon":"SNTQrhEQ"};